import React from 'react'
import { Link } from 'react-router-dom'
const Login = () => {
    return (
        <div className="signInUp">
            <div className="signInUp__wrapper">
                <div className="signInUp__wrapper__buttons signInUp__wrapper__buttons--login">
                    <form action="#">
                        <input type="email" className="inputAlpha" placeholder="Email" />
                        <input type="password" className="inputAlpha" placeholder="Senha" />
                    </form>
                    <Link to="/home" className="defaultBtn">Entrar</Link>
                    <Link to="/signup" className="defaultLink">Não tem conta? Cadastre-se.</Link>
                </div>
            </div>
        </div>
    )
}

export default Login
